var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenScoreA(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 130,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#1d1d1b",
    d: "M148.955 39.38h-26.141c.825 6.052 6.009 9.113 11.118 9.113 7.511 0 11.267-3.645 11.267-3.645v7.29s-3.756 3.649-11.267 3.649c-11.268 0-18.78-7.292-18.78-18.233s7.512-18.234 16.904-18.234c9.39 0 16.901 7.29 16.901 18.234v1.825zm-25.916-5.474h18.03c-1.053-4.883-4.434-7.29-9.018-7.29-4.58 0-7.96 2.407-9.012 7.293zM179.106 21.145v7.293s-5.473-1.825-9.116-1.825c-5.473 0-10.939 3.648-10.939 10.941 0 7.291 5.47 10.94 10.939 10.94 3.648 0 9.114-1.826 9.114-1.826v7.296s-3.646 1.823-9.114 1.823c-10.939 0-18.234-7.292-18.234-18.233S159.05 19.32 169.99 19.32c5.468 0 9.114 1.825 9.114 1.825zM218.342 37.556c0 10.94-7.293 18.233-18.232 18.233-10.941 0-18.234-7.291-18.234-18.233s7.293-18.234 18.234-18.234c10.939 0 18.232 7.293 18.232 18.234zm-29.173 0c0 7.292 5.473 10.94 10.941 10.94 5.47 0 10.939-3.648 10.939-10.94 0-7.295-5.473-10.94-10.939-10.94-5.47 0-10.941 3.645-10.941 10.94zM123.174 109.541c-3.714 0-7.426-1.236-7.426-1.236v-4.95s3.712 1.236 7.426 1.236c2.471 0 3.711-1.236 3.711-2.471 0-3.714-11.717-1.24-11.717-9.902 0-4.948 3.056-7.426 8.006-7.426 3.714 0 7.428 1.24 7.428 1.24v4.948s-3.714-1.236-7.428-1.236c-2.472 0-3.712 1.236-3.712 2.472 0 3.714 12.375 1.238 12.375 9.901-.002 4.95-3.716 7.426-8.663 7.426zM151.881 86.032v4.948s-3.711-1.236-6.187-1.236c-3.712 0-7.426 2.472-7.426 7.424 0 4.95 3.714 7.425 7.426 7.425 2.476 0 6.187-1.238 6.187-1.238v4.948s-2.473 1.24-6.187 1.24c-7.426 0-12.374-4.95-12.374-12.375 0-7.426 4.948-12.376 12.374-12.376 3.714 0 6.187 1.24 6.187 1.24zM178.663 97.168c0 7.425-4.95 12.375-12.376 12.375-7.426 0-12.375-4.95-12.375-12.375 0-7.426 4.95-12.376 12.375-12.376 7.426 0 12.376 4.95 12.376 12.376zm-19.802 0c0 4.95 3.712 7.425 7.426 7.425s7.426-2.473 7.426-7.425c0-4.95-3.712-7.426-7.426-7.426s-7.426 2.476-7.426 7.426zM195.64 84.792v4.95c-4.95 0-9.902 1.238-9.902 7.426v12.375h-4.948v-24.75h4.948v9.9c.002-6.187 3.713-9.9 9.901-9.9zM218.161 98.406h-17.226c.545 4.109 3.961 6.187 7.327 6.187 4.95 0 7.426-2.473 7.426-2.473v4.947s-2.476 2.476-7.426 2.476c-7.426 0-12.376-4.95-12.376-12.375 0-7.426 4.95-12.376 11.138-12.376s11.135 4.95 11.135 12.376v1.238zm-17.078-3.712h11.881c-.692-3.317-2.92-4.95-5.938-4.95-3.023 0-5.248 1.633-5.943 4.95z",
    style: {
      strokeWidth: 1.636
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-44.151 174.2)",
    stroke: "#fff",
    strokeWidth: 1.859
  }, /*#__PURE__*/React.createElement("rect", {
    x: 236.495,
    y: -112.07,
    width: 29.127,
    height: 15.803,
    rx: 7.902,
    fill: "#bf3122"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.382,
    y: -112.07,
    width: 29.127,
    height: 15.803,
    rx: 7.902,
    fill: "#de4523"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.269,
    y: -112.07,
    width: 29.127,
    height: 15.803,
    rx: 7.902,
    fill: "#ef7e1a"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.156,
    y: -112.07,
    width: 29.127,
    height: 15.803,
    rx: 7.902,
    fill: "#f5c100"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.043,
    y: -112.07,
    width: 29.127,
    height: 15.803,
    rx: 7.902,
    fill: "#2ecc71"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.93,
    y: -112.07,
    width: 29.127,
    height: 15.803,
    rx: 7.902,
    fill: "#1e8f4e"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.001 109.318C.001 120.723 9.682 130 21.579 130h196.85c11.894 0 21.573-9.28 21.573-20.682V20.681C240.002 9.277 230.322 0 218.428 0H21.577C9.682 0 0 9.279 0 20.68Z",
    style: {
      strokeWidth: 1.636
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e8f4e",
    fillRule: "evenodd",
    d: "M2.35 109.318c0 10.017 8.535 18.334 19.229 18.334h196.85c10.693 0 19.227-8.32 19.227-18.334V20.681c0-10.016-8.534-18.333-19.228-18.333H21.577c-10.694 0-19.228 8.32-19.228 18.333zM21.578 130C9.684 130 0 120.723 0 109.318V20.681C.001 9.28 9.68 0 21.577 0h196.851c11.895 0 21.574 9.277 21.574 20.681v88.64c0 11.402-9.68 20.681-21.574 20.681z",
    clipRule: "evenodd",
    style: {
      strokeWidth: 1.636
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e8f4e",
    d: "M100.57 18.064c1.589-.132 3.065 1.34 2.928 2.929-.196 2.266-3.014 53.75-19.49 70.225-15.792 15.79-34.397 12.084-46.547 3.35a13.395 13.395 0 0 1-.494-.377l-10.953 10.936a6.775 6.775 0 0 1-9.581-9.581l10.939-10.95a13.141 13.141 0 0 1-.38-.497c-8.732-12.148-12.44-30.753 3.35-46.547 16.478-16.476 67.96-19.296 70.228-19.488Z",
    style: {
      strokeWidth: 1.636
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72.264 81.118c2.374 0 4.073-1.589 4.073-3.829 0-.81-.134-1.538-.514-2.59L65.143 45.73c-1.16-3.182-3.048-4.585-6.23-4.585-3.077 0-4.992 1.456-6.124 4.612L42.161 74.698c-.35 1-.538 1.916-.538 2.591 0 2.346 1.589 3.831 4.126 3.831 2.159 0 3.372-1.081 4.127-3.67l2.05-6.068H65.98l2.05 6.15c.728 2.535 1.942 3.588 4.235 3.588zM64.092 65.07H53.707l5.042-15.941h.19z",
    style: {
      strokeWidth: 1.636
    }
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(99.997 -97.488) scale(.9273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.537 129.227v24.909c0 6.227-3.8 9.963-10.135 9.963-5.068 0-7.601-3.736-7.601-3.736v-6.227s3.8 4.981 7.601 4.981c3.8 0 5.068-2.491 5.068-4.981v-3.089c-1.42.299-3.244.598-5.068.598-6.334 0-11.402-4.982-11.402-11.209 0-6.227 5.068-11.209 11.402-11.209zm-10.135 17.436c1.368 0 3.446-.349 5.068-.697v-11.757h-5.068c-3.8 0-6.334 2.491-6.334 6.227s2.533 6.227 6.334 6.227zM45.166 139.191c0-6.228 3.8-9.964 10.135-9.964v4.982c-5.068 0-10.135 1.245-10.135 7.472v12.455h-5.068v-24.909h5.068zM78.894 141.681v1.246H61.26c.558 4.135 4.054 6.227 7.5 6.227 5.068 0 7.602-2.491 7.602-2.491v4.982s-2.534 2.491-7.602 2.491c-7.601 0-12.669-4.982-12.669-12.455 0-7.472 5.068-12.454 11.402-12.454 6.335 0 11.402 4.982 11.402 12.454zm-11.402-7.472c-3.09 0-5.371 1.644-6.08 4.982h12.162c-.71-3.338-2.99-4.982-6.082-4.982zM103.725 141.681v1.246H86.09c.558 4.135 4.054 6.227 7.5 6.227 5.068 0 7.602-2.491 7.602-2.491v4.982s-2.534 2.491-7.602 2.491c-7.601 0-12.669-4.982-12.669-12.455 0-7.472 5.068-12.454 11.402-12.454 6.335 0 11.402 4.982 11.402 12.454zm-11.402-7.472c-3.09 0-5.371 1.644-6.08 4.982h12.161c-.709-3.338-2.99-4.982-6.08-4.982zM120.955 129.227c5.068 0 8.868 3.736 8.868 9.964v14.945h-5.067v-12.455c0-4.981-2.534-7.472-6.335-7.472-3.8 0-6.334 2.491-6.334 7.472v12.455h-5.068v-24.909h5.068v9.964c0-6.228 3.801-9.964 8.868-9.964z",
    fill: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.667,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#bf3122",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.333,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#de4523",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#ef7e1a",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.667,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#f5c100",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30.333,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#2ecc71",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 165.5,
    width: 31.333,
    height: 17,
    rx: 8.5,
    fill: "#1e8f4e",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.352 193.401V199s-4.182-1.401-6.969-1.401c-4.182 0-8.363 2.8-8.363 8.401 0 5.599 4.181 8.401 8.363 8.401 2.787 0 6.969-1.401 6.969-1.401v5.599S52.565 220 48.383 220c-8.363 0-13.937-5.599-13.937-14s5.574-14 13.937-14c4.182 0 6.969 1.401 6.969 1.401zM23.018 220c-4.182 0-8.364-1.401-8.364-1.401V213s4.182 1.401 8.364 1.401c2.787 0 4.182-1.401 4.182-2.8 0-1.662-2.067-2.228-4.564-2.912-3.815-1.045-8.636-2.366-8.636-8.288 0-5.599 3.444-8.401 9.02-8.401 4.182 0 8.364 1.401 8.364 1.401V199s-4.182-1.401-8.364-1.401c-2.787 0-4.181 1.401-4.181 2.8 0 1.662 2.181 2.228 4.819 2.912 4.028 1.045 9.118 2.366 9.118 8.288-.002 5.601-4.184 8.401-9.758 8.401zm62.494-14c0 8.401-5.574 14-13.938 14-8.363 0-13.937-5.599-13.937-14s5.574-14 13.937-14c8.364 0 13.938 5.599 13.938 14zm-22.299 0c0 5.599 4.182 8.401 8.364 8.401 4.181 0 8.363-2.8 8.363-8.401 0-5.599-4.182-8.401-8.363-8.401-4.182 0-8.364 2.802-8.364 8.401zm41.422-14v5.599c-5.574 0-11.15 1.401-11.15 8.401v14H87.91v-28h5.574v11.2c0-7 4.182-11.2 11.151-11.2zM130 207.401h-19.398c.613 4.649 4.459 7 8.25 7 5.574 0 8.363-2.8 8.363-2.8v5.599s-2.787 2.8-8.363 2.8c-8.363 0-13.937-5.599-13.937-14s5.574-14 12.542-14c6.969 0 12.543 5.599 12.543 14zm-19.232-4.201h13.38c-.779-3.752-3.288-5.599-6.688-5.599-3.403-.002-5.912 1.847-6.692 5.599z",
    fill: "#1d1d1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenScoreA);
export default __webpack_public_path__ + "static/media/green-score-a.7d223fef95d1f71b99b5c9f303a1657c.svg";
export { ForwardRef as ReactComponent };